import type React from 'react';

import { Field } from 'react-final-form';

import { TextField } from '@change/ds-forms';

import { translationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useFormI18n } from 'src/app/shared/form/hooks';
import { requiredValidator } from 'src/app/shared/form/validators';

import type { FormValues, ReportType } from '../shared/types';

type Props = Readonly<{
	type: ReportType;
}>;

const validator = requiredValidator({
	i18n: { key: translationKey('fe.components.petition_report_abuse.errors.reason_required') },
});

export const ReasonField: React.FC<Props> = ({ type }) => {
	const { translate } = useI18n();
	const { getErrorMessage } = useFormI18n();

	return (
		<div className="mb-4">
			<Field<FormValues['reason'] | undefined> name="reason" validate={validator}>
				{({ input, meta }) => (
					<TextField
						inputOptions={{ className: 'h-20' }}
						id="report-abuse-reason"
						name={input.name}
						value={input.value}
						onChange={input.onChange}
						onFocus={input.onFocus}
						onBlur={input.onBlur}
						// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
						errorMessage={meta.touched && getErrorMessage(meta.error)}
						isInvalid={meta.touched && !!meta.error}
						inputElementType="textarea"
						placeholder={translate(`fe.components.${type}_report_abuse.form_placeholder`)}
						aria-label={translate(`fe.components.${type}_report_abuse.form_placeholder`)}
						label={translate(`fe.components.${type}_report_abuse.form_placeholder`)}
						data-testid="reportAbuse-reason-input"
					/>
				)}
			</Field>
		</div>
	);
};
